import { style } from '@/components/base';
export const getStyle = ({ isSmall, linksHoverColor, showMenuLinksBold }) => {
  if (isSmall) {
    return `
      ${style(`
        .menu-tabs {
          display: flex;
          gap: 0.5rem;
          padding: 1rem;
          flex-wrap: wrap;
        }

        .tab-button {
          padding: 0.5rem 1rem;
          font-weight: 500;
          border: 2px solid #89E5D3;
          border-radius: 0.5rem;
          background-color: white;
          color: #000000;
          font-size: 16px;
          cursor: pointer;
        }

        .tab-button.active {
          font-weight: 700;
          background-color: #ecfdf5;
        }

        .mobile-content {
          padding: 1rem;
          padding-top: 0px;
          display: flex;
          flex-direction: column;
          gap: 2rem;
        }

        .text-links-section {
          background-color: #F0F9F7;
          padding: 1.5rem;
          padding-bottom: 12px;
          padding-top: 12px;
          border-radius: 0.5rem;
          display: flex;
          flex-direction: column;
          gap: 34px;
        }

        .text-links-section a {
          font-size: 16px;
          color: #111827;
          text-decoration: none;
          display: flex;
          align-items: center;
          gap: 34px;
          font-family: GT-America-Standard-Regular, HelveticaNeue, Helvetica Neue, Helvetica, Arial, sans-serif
        }

        .image-cards-section {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
          align-items: center;
        }

        .card {
          background-color: #ffffff;
          overflow: hidden;
          width: 100%;
          max-width: 100%;
          position: relative;

        }

        .card img {
          width: 100%;
          height: 164px;
          object-fit: cover;
          aspect-ratio: 2 / 1;
          object-position: top;
        }

        .card .p-4 {
          padding: 1rem;
          text-align: center;
        }

        .card p {
          font-size: 1.25rem;
          font-weight: 600;
          color: #111827;
          margin-top: 0.5rem;
        }

        .new-badge {
          font-size: 0.75rem;
          font-weight: 600;
          padding: 0.125rem 0.5rem;
          border-radius: 9999px;
          background-color: #5eead4;
          color: #134e4a;
          white-space: nowrap;
        }
    `)}`;
  }
  return `
    ${style(`
      /* Custom styles for the NEW badge */
      .new-badge {
        font-size: 0.75rem;
        font-weight: 600;
        padding: 0.125rem 0.5rem;
        border-radius: 10px;
        background-color: #5eead4;
        color: #134e4a;
        white-space: nowrap;
      }

      .menu-sidebar a:hover {
        color: ${linksHoverColor}
      }

      .text-links-section a:hover {
        color: ${linksHoverColor}; /* indigo-600 */
      }

      /* Ensure images in cards are responsive */
      .card img {
        width: 180px;
        height: 180px;
        object-fit: cover;
      }

      .main-menu-container {
        height: 100%;
        display: flex;
        flex-direction: row;
        width: 100vw;
        max-width: 1345px;
        margin: 0 auto;
        overflow: hidden;
      }

      @media (min-width: 768px) {
        .main-menu-container {
            flex-direction: row;
        }
      }

      .menu-sidebar {
        background-color: #F0F9F7; /* Tailwind's green-50 for soft green */
        padding: 2rem 0;
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
      }

      @media (min-width: 768px) {
        .menu-sidebar {
            width: 25%; /* md:w-1/4 */
        }
      }

      @media (min-width: 1024px) {
        .menu-sidebar {
            width: 20%; /* lg:w-1/5 */
        }
      }

      .menu-sidebar ul {
        list-style: none;
        padding: 0;
        margin: 0;
      }

      .menu-sidebar li {
        /*margin-bottom: 1rem;*/ /* space-y-4 */
      }

      .menu-sidebar li:last-child {
        margin-bottom: 0;
      }

      .menu-sidebar a {
        font-size: 1rem;
        font-weight: ${showMenuLinksBold ? '700' : '400'};
        color: #111827; /* Tailwind gray-900 */
        text-decoration: none;
        display: block;
        padding: 0.25rem 0;
        cursor: pointer;
        font-family: GT-America-Standard-Regular, HelveticaNeue, Helvetica Neue, Helvetica, Arial, sans-serif;
      }

      .menu-sidebar a.active {
        font-weight: 700;
        text-decoration: underline;
      }

      .menu-content {
        flex-grow: 1;
        background-color: #ffffff;
        padding: 2rem 3rem;
        display: flex;
        flex-direction: row;
        gap: 2rem;
      }

      @media (min-width: 768px) {
        .menu-content {
            padding: 2rem;
        }
      }

      @media (min-width: 1024px) {
        .menu-content {
            flex-direction: row;
        }
      }

      .text-links-section {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        gap: 1.25rem;
      }

      @media (min-width: 1024px) {
        .text-links-section {
            grid-template-columns: repeat(2, 1fr);
            gap: 1.5rem; /* lg:gap-6 */
        }
      }

      .text-links-section a {
        color: #111827;
        font-size: 1rem;
        font-weight: 400;
        text-decoration: none;
        display: flex;
        align-items: center;
        gap: 0.5rem;
        font-family: GT-America-Standard-Regular, HelveticaNeue, Helvetica Neue, Helvetica, Arial, sans-serif;
      }

      .image-cards-section {
        flex: 1;
        display: flex;
        flex-direction: row;
        gap: 3.5rem;
        justify-content: center;
        align-items: flex-start;
      }

      @media (min-width: 640px) {
        .image-cards-section {
            flex-direction: row;
        }
      }

      .card {
        background-color: #ffffff;
        flex: 1;
        max-width: 146px;
        position: relative;
        display: flex;
        flex-direction: column;
      }

      @media (min-width: 640px) {
        .card {
          width: 48%; /* sm:w-1/2, slightly less than 50% to account for gap */
        }
      }

      @media (min-width: 1024px) {
        .card {
          width: auto; /* lg:w-auto - let flex basis determine, or set a max-width if needed */
          flex-basis: 48%; /* Adjust to fit two cards with a gap */
        }
      }

      .card .p-4 {
        padding: 0;
        font-size: 0.9rem;
        line-height: normal;
        text-align: left;
      }

      .card p {
        color: #1f2937;
        font-weight: 500;
      }

      .card .new-badge {
        position: absolute;
        top: 0.5rem; /* top-2 */
        right: 0.5rem; /* right-2 */
      }
  `)}`;
};
